export default {"src":"/_next/static/media/stears-dashboard-v2.00dd9492.svg","height":498,"width":817,"blurWidth":0,"blurHeight":0};